
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiFuse02On as ObiFuse02OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-fuse-02-on.js';
 
 
 

 
 export const ObiFuse02On = createComponent({
   react: React,
   tagName: 'obi-fuse-02-on',
   elementClass: ObiFuse02OnElement,
   events: {
     
   }
  });
 
 